import React from "react";

/** Placeholder for CAiRE tabs until real endpoints / UIs are available. */
const CaireEmptyList: React.FC = () => {
  return (
    <div className="flex h-full items-center justify-center bg-white px-4">
      <p className="text-sm text-gray-500">Content coming soon.</p>
    </div>
  );
};

export default CaireEmptyList;
